// extracted by mini-css-extract-plugin
export default {"tagsTopCities":"aBiTcU"};